export enum ApplePayStatus {
  Success = 0,
  Failed = 1,
}
